export const MoonIcon = ({
  width = 15,
  height = 15,
}: {
  width?: number;
  height?: number;
}) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M14.596 8.8894C14.5319 8.82513 14.4515 8.77954 14.3634 8.75752C14.2753 8.73549 14.1829 8.73787 14.096 8.7644C13.1426 9.05263 12.1289 9.07679 11.1629 8.83432C10.1968 8.59186 9.31464 8.09184 8.61036 7.38756C7.90608 6.68327 7.40606 5.80111 7.16359 4.83507C6.92113 3.86902 6.94529 2.85529 7.23352 1.9019C7.26027 1.81503 7.26283 1.72251 7.24093 1.63428C7.21902 1.54606 7.17349 1.46548 7.10921 1.40121C7.04494 1.33693 6.96436 1.29139 6.87614 1.26949C6.78791 1.24759 6.69539 1.25015 6.60852 1.2769C5.29041 1.68068 4.13323 2.4899 3.30164 3.5894C2.5744 4.55494 2.1308 5.70413 2.02068 6.90788C1.91057 8.11163 2.13829 9.32224 2.67827 10.4037C3.21826 11.4852 4.04911 12.3946 5.07748 13.0299C6.10585 13.6652 7.29099 14.0012 8.49977 14C9.90998 14.0044 11.2827 13.5459 12.4073 12.695C13.5068 11.8634 14.316 10.7063 14.7198 9.38815C14.7462 9.3016 14.7487 9.2095 14.7269 9.12166C14.7051 9.03383 14.6599 8.95355 14.596 8.8894ZM11.806 11.8963C10.747 12.6939 9.43545 13.0822 8.11286 12.9896C6.79027 12.897 5.54565 12.3297 4.60811 11.3923C3.67056 10.4548 3.10322 9.21023 3.0105 7.88765C2.91778 6.56506 3.30594 5.2535 4.10352 4.1944C4.62315 3.50819 5.29493 2.95193 6.06602 2.5694C6.02209 2.87767 5.99995 3.18865 5.99977 3.50003C6.00159 5.22337 6.68699 6.87562 7.90558 8.09421C9.12418 9.3128 10.7764 9.99821 12.4998 10C12.8118 9.99993 13.1234 9.97779 13.4323 9.93378C13.0494 10.705 12.4927 11.3768 11.806 11.8963Z"
      fill="#202020"
    />
  </svg>
);
